import React, { Fragment } from "react";
import Slider from "react-slick";
import { getAllAuthors } from "../../services/Author";
import "./Authors.css";
import Modal from "react-responsive-modal";

export default class Authors extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      authors: [],
      open: false,
      authorModal: {}
    };
  }

  async componentDidMount() {
    try {
      let { data: authors } = await getAllAuthors();
      this.setState({ authors: authors });
    } catch (Error) {
      alert(Error);
    }
  }

  handlerOpenModal(author) {
    this.setState({ open: true, authorModal: author });
  }

  handlerCloseModal() {
    this.setState({ open: false });
  }

  render() {
    const { open } = this.state;

    const settings = {
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: false,
      speed: 200,
      arrows: true,
      dotsClass: "authors-card-dots",
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            autoplaySpeed: 2500
          }
        }
      ]
    };

    return (
      <Fragment>
        <section id="Authors" className="container authors">
          <h3 className="authors__title">AUTORES</h3>
          <h4 className="title-publisher-2">
            Se há algo mais importante para nós, são eles!
          </h4>
          <div style={{ textAlign: "center" }}>
            <Slider {...settings}>
              {this.state.authors.map((author, index) => (
                <div className="authors__author" key={index}>
                  <div className="authors__author__content">
                    <figure>
                      <img
                        style={author.image ? {} : { visibility: "hidden" }}
                        src={author.image ? author.image : null}
                        alt="author-foto"
                      />
                    </figure>
                    <div className="authors__author__content__info">
                      <h4>{author.nome}</h4>
                      <p className="">
                        {author.biografia.substr(0, 150)}
                        {author.biografia.length <= 200 ? "" : "..."}
                      </p>
                      <button
                        className="button-contents"
                        onClick={this.handlerOpenModal.bind(this, author)}
                      >
                        +
                        </button>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </section>
        <div className="center">
        <Modal
          closeOnOverlayClick={true}
          closeOnEsc={true}
          styles={{ height: "auto"}}
          colos
          center={true}
          classNames={{
            overlay: "modal-authors",
            transitionEnter: "transition-enter",
            transitionEnterActive: "transition-enter-active",
            transitionExit: "transition-exit-active",
            transitionExitActive: "transition-exit-active",
          }}
          closeIconSvgPath={
            <path
              d="M20.1096151,17.5 L24.4544145,21.8447994 C25.1775577,22.5679426 25.184623,23.7333242 24.4589736,24.4589736 C23.7383483,25.1795989 22.5738487,25.1834638 21.8447994,24.4544145 L17.5,20.1096151 L13.1552006,24.4544145 C12.4320574,25.1775577 11.2666758,25.184623 10.5410264,24.4589736 C9.8204011,23.7383483 9.81653616,22.5738487 10.5455855,21.8447994 L14.8903849,17.5 L10.5455855,13.1552006 C9.8224423,12.4320574 9.81537704,11.2666758 10.5410264,10.5410264 C11.2616517,9.8204011 12.4261513,9.81653616 13.1552006,10.5455855 L17.5,14.8903849 L21.8447994,10.5455855 C22.5679426,9.8224423 23.7333242,9.81537704 24.4589736,10.5410264 C25.1795989,11.2616517 25.1834638,12.4261513 24.4544145,13.1552006 L20.1096151,17.5 Z"
              id="Combined-Shape"
              fill="#9B9B9B"
            />
          }
          open={open}
          onClose={this.handlerCloseModal.bind(this)}
        >
            <div className="authors__modal">
              <img src={this.state.authorModal.image} alt="autor" />
              <h2>{this.state.authorModal.nome}</h2>
              <p>{this.state.authorModal.biografia}</p>
            </div>
        </Modal>
      </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Authors/Authors.js